/*
 * @Author: your name
 * @Date: 2021-07-08 10:18:17
 * @LastEditTime: 2021-12-10 09:59:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \foxit_print\src\const\const.js
 */
export const REQUEST_URL = "https://dyapi.foxitcloud.cn";
export const IAM_URL = "https://account.foxitreader.cn";
export const APP_KEY = "pfvoKLyG";
export const CLOUD_REQUEST_URL = "https://webapi.foxitcloud.cn";
export const PAGE_DATA = [
  {
    value: "1",
    label: "1份",
  },
  {
    value: "2",
    label: "2份",
  },
  {
    value: "3",
    label: "3份",
  },
  {
    value: "4",
    label: "4份",
  },
  {
    value: "5",
    label: "5份",
  },
  {
    value: "6",
    label: "6份",
  },
  {
    value: "7",
    label: "7份",
  },
  {
    value: "8",
    label: "8份",
  },
  {
    value: "9",
    label: "9份",
  },
  {
    value: "10",
    label: "10份",
  },
  {
    value: "20",
    label: "20份",
  },
  {
    value: "30",
    label: "30份",
  },
  {
    value: "40",
    label: "40份",
  },
  {
    value: "50",
    label: "50份",
  },
  {
    value: "60",
    label: "60份",
  },
  {
    value: "70",
    label: "70份",
  },
  {
    value: "80",
    label: "80份",
  },
  {
    value: "90",
    label: "90份",
  },
  {
    value: "100",
    label: "100份",
  },
];
